module.exports = __webpack_public_path__ + "80b7538fee020bd086a4083bce58a417.pdf";